module.exports = __webpack_public_path__ + "static/media/Statua_043.66593002.jpg";